import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'claimsaved',
  templateUrl: './claimsaved.component.html',
  styleUrls: ['./claimsaved.component.scss'],
})
export class ClaimsavedComponent implements OnInit {
  constructor(private modalCtrl: PopoverController) { }

  ngOnInit() { }

  close() {
    this.modalCtrl.dismiss();
  }
}
